import { NetworkConnectivity } from '@dateam/ark';
import config from 'config';

const connectivity = new NetworkConnectivity({ endpoint: config.apiUrl });
// console.log(connectivity.isOnline); // TODO: Clean
// connectivity.subscribe(isOnline => console.log('isOnline', isOnline));

export default connectivity;